module.exports = __webpack_public_path__ + "img/67_16.ebb7c2fc.png";